import * as Yup from 'yup';

import { getTimezone } from '../formatDate';
import { validateField, ValidationType } from './formValidation';
import type { CalendarReminderFormInterface } from 'types';

export const calendarReminderDefaultValues: CalendarReminderFormInterface = {
    title: 'Client document review',
    date: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    time: new Date().toTimeString().slice(0, 5),
    description: '',
    timezone: getTimezone(),
    add_all_agents: false,
    add_client: false,
};

export const calendarReminderValidationSchema = Yup.object({
    title: validateField(ValidationType.STRING),
    date: validateField(ValidationType.STRING),
    time: validateField(ValidationType.STRING),
    description: validateField(ValidationType.STRING, false),
    timezone: validateField(ValidationType.STRING),
    add_all_agents: validateField(ValidationType.BOOLEAN_VALUE, false),
    add_client: validateField(ValidationType.BOOLEAN_VALUE, false),
});
